module.exports = __webpack_public_path__ + "assets/img/五档.92da6779.png";